import { Component, ElementRef, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";
// import { AuthService } from '../../service/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../loginone/login.service';
import { ValidateService } from 'app/shared/validate.service';
import { ActivatedRoute } from '@angular/router';
import { animate, state, style, transition, trigger } from "@angular/animations";

@Component({
  selector: 'ms-forgot-password',
  templateUrl: './forgot-password-component.html',
  styleUrls: ['./forgot-password-component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class ForgotPasswordComponent {

  // email: string;
  isOTPSend = false;
  EnteredOTP = '';
  UserEmail: string = '';
  isInProgress = false;
  isOTPVerify = false;
  hide = true;
  hide1 = true;
  hide2 = true;
  NewPassword = '';
  ConfirmPassword = '';
  type: string = '';  // if forgot password then password and if forgot userid then userID

  itemToEditForgotPassword = {
    'UserName': this.UserEmail,
    'OldPassword': '',
    'NewPassword': '',
    'ConfirmPassword': '',
    'Type': ''
  };

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    // private authService: AuthService,
    private loginService: LoginService,
    public validateService: ValidateService,
    private toasterService: ToastrService,
    public translate: TranslateService) { }

  /**
    * forgetPassword is used to send a reset password OTP into your mail.
    */
  forgetPassword() {
    if (this.UserEmail != undefined || this.UserEmail != null || this.UserEmail != '') {
      this.isInProgress = true;
      // this.UserEmail = email;
      this.otp = ['', '', '', '']; // Reset OTP input
      this.loginService.ForgetPassword(this.UserEmail, '', 'Forgot', "").subscribe((data) => {
        if (data.toString().includes('successfully')) {
          this.isOTPSend = true;
          if (this.ResendCount == 0) {
            this.toasterService.success(data.toString());
            this.startResendTimer();
          } else {
            this.toasterService.success("A new OTP has been sent to your email. The previous OTP is no longer valid.");
          }
        } else if (data.toString().includes('not registered')) {
          this.isOTPSend = false;
          this.toasterService.warning(data.toString());
        }
        else {
          this.isOTPSend = false;
          this.toasterService.error(data.toString());
        }
        this.isInProgress = false;
      });
    } else {
      this.toasterService.warning("Please Enter Email ID !!");
    }
  }
  otp: string[] = new Array(4).fill('');
  errorMessage: string = '';

  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

  onInput(event: any, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.trim();
    this.otp[index] = value; // Assign the digit properly
    setTimeout(() => {
      const nextInput = this.otpInputs.toArray()[index + 1];
      if (nextInput) {
        nextInput.nativeElement.value = ''
        nextInput.nativeElement.focus();
      }
    });
    // Auto-focus to the next field
  }

  onKeyDown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      this.otp[index] = '';
      setTimeout(() => {
        if (index > 0) {
          this.otpInputs.toArray()[index - 1].nativeElement.focus();
        }
      });

    }
  }

  // Verify user OTP
  verifyOtp(): void {
    const enteredOtp = this.otp.join('');
    if (enteredOtp.length !== this.otp.length) {
      this.errorMessage = 'Please enter the complete OTP.';
      return;
    }
    this.errorMessage = '';
    this.loginService.verifyOtp(this.UserEmail, enteredOtp, 'Forgot').subscribe((data) => {
      if (data.toString() == 'OK') {
        this.isOTPVerify = true;
        this.otp = ['', '', '', '']; // Reset OTP input
        this.toasterService.success("OTP verified successfully.");
      } else if (data.toString() == 'Please enter correct OTP') {
        this.isOTPVerify = false;
        this.toasterService.warning("Incorrect OTP. Please enter the correct OTP.");
      } else if (data.toString() == 'OTP Expire') {
        this.isOTPVerify = false;
        this.toasterService.warning('The OTP has expired. Please request a new one.');
      } else {
        this.isOTPVerify = false;
        this.toasterService.error('An error occurred while verifying OTP. Please try again.');
      }
    });
  }

  ResendCount = 0;
  // Resend OTP 1 time
  resendOtp(): void {
    this.toasterService.info('Resending OTP... Please check your email.');
    this.errorMessage = '';
    this.ResendCount = 1;
    this.otp = ['', '', '', '']; // Reset OTP input
    this.isResendUsed = true;
    this.forgetPassword();
  }

  isResendDisabled: boolean = false;
  isResendUsed: boolean = false; // Track if resend has been used
  countdown: number = 60;
  timer: any;

  startResendTimer() {
    this.isResendDisabled = true;
    this.countdown = 60;
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.isResendDisabled = false;
        clearInterval(this.timer);
      }
    }, 1000);
  }

  // Save Change Password
  SaveForgotPassword() {
    this.isInProgress = true;
    if (this.NewPassword == '' || this.ConfirmPassword == '') {
      this.isInProgress = false;
      this.toasterService.warning('All fields are required. Please fill in both password fields.');
    } else {
      if (this.NewPassword !== this.ConfirmPassword) {
        this.isInProgress = false;
        this.toasterService.warning('New password and confirm password do not match. Please re-enter.');
      } else {
        this.itemToEditForgotPassword.UserName = this.UserEmail;
        this.itemToEditForgotPassword.NewPassword = this.NewPassword;
        this.itemToEditForgotPassword.Type = this.type;  // reset password / reset user id
        this.loginService.SaveForgotPassword(this.itemToEditForgotPassword).subscribe(data => {

          if (data == "OK") {
            this.toasterService.success("UserID/Password changed successfully!");
            // this.router.navigate(['/session/home']);
            this.router.navigateByUrl('/session/home').then(() => {
              // Then hide the route from the URL
              history.replaceState({}, '', '/');
            });
            this.Clear();
          } else if (data == "Failed") {
            this.toasterService.warning('Failed to change userID/password. Please try again.');
          } else {
            this.toasterService.warning('Failed to change userID/password. Please try again.');
          }
          this.isInProgress = false;
        });
      }
    }
  }
  Clear() {
    this.NewPassword = '';
    this.ConfirmPassword = '';
  }

  goHome() {
    // Navigate again programmatically
    this.router.navigateByUrl('/session/home').then(() => {
      // Then hide the route from the URL
      history.replaceState({}, '', '/');
    });
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.type = params['type']; // 'password' or 'userID' depedning on what option is clicked forgot password or user id
    });
  }
}